import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedRequest } from "../../../AbstractApiClient/IApiRequest";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetLaborPosterRequestSchema,
  TGetLaborPosterResponseSchema,
} from "./getLaborPoster.schema";

export const getLaborPoster = (axios: IAxiosInstance) => {
  return async ({
    labor_poster_id,
  }: TApiPaginatedRequest<TGetLaborPosterRequestSchema>) => {
    const response = await axios.noRetry.get<
      TApiPaginatedResponse<TGetLaborPosterResponseSchema>
    >(`/labor-posters/${labor_poster_id}`);
    return response.data;
  };
};
